import type { Round } from './bracket'

export interface LeaderboardEntry {
  rank: number
  player_id: string
  display_name: string
  is_ai: number
  group_id: string | null
  total_points: number
  r32_pts: number
  r16_pts: number
  qf_pts: number
  sf_pts: number
  final_pts: number
  champion_pts: number
  created_at: number
  r32_picks: number
  current_streak: number
  best_streak: number
}

export interface PlayerGroup {
  id: string
  name: string
  created_at: number
}

export const ROUND_POINTS: Record<Round, number> = {
  R32: 1,
  R16: 2,
  QF: 4,
  SF: 8,
  '3RD': 8,
  FINAL: 16,
}

export const ROUND_LABELS: Record<Round, string> = {
  R32: 'Round of 32',
  R16: 'Round of 16',
  QF: 'Quarterfinals',
  SF: 'Semifinals',
  '3RD': '3rd Place',
  FINAL: 'Final',
}

export const EXACT_SCORE_BONUS = 3
export const MAX_SCORE = 338
